/*计算峰值/最低值/平均值*/
function echartsLoad(arr){
	this.arr = arr;
	this.max = this.MaxMin("max",this.arr);
	this.min = this.MaxMin("min",this.arr);
	this.multiple = this.mul(this.max);
	this.maxPow = this.pow(this.max);
	this.minPow = this.pow(this.min);
	this.NUM = 1;

}
echartsLoad.prototype.ReturnNum=function() {
	var max = this.maxPow*this.multiple==this.NUM ? 0 : this.maxPow*this.multiple,
		min = this.minPow==this.NUM ? 0 : this.minPow;
	return {
		"max":max,
		"min":min,
		"int":(max-min)/10
	}
};
echartsLoad.prototype.MaxMin=function(type,arr){
	return Math[type].apply(null,arr)
};
echartsLoad.prototype.pow=function(num){
	return Math.pow(10,(num.toFixed().length-1))
};
echartsLoad.prototype.mul=function(num){
	return ++(num.toString().split("")[0])
};


function strArrs(arr,arrlength){
	var strArrs = [];
	for(var i=0;i<arrlength;i++){
		var num =0;
		for(var j=0;j<arr[i].data.length;j++){
			num+=parseInt(arr[i].data[j])
		}
		strArrs.push( {
			name:arr[i].name,
			value:num
		})
	}
	return strArrs;
}

function datastatOrder(arr){
	var newArr = {
		bar:[],
		line:[]
	};
	for(var i=0;i<arr.length;i++){
		if((arr.length/2)<=i){
			newArr.line.push(arr[i].name)
		}else{
			newArr.bar.push(arr[i].name)
		}
	}
	return newArr;
}

export default echartsLoad




// WEBPACK FOOTER //
// ./src/assets/echaAverage.js